import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
} from "@mui/material";
import { useGetQuizAnalyticsQuery } from "../../Apis/progressApi";

// Helper component for the inline percentage bar
const MultiColorBar = ({ correct, wrong }: { correct: number; wrong: number }) => {
  const total = correct + wrong || 1;
  const correctWidth = (correct / total) * 100;
  const wrongWidth = (wrong / total) * 100;

  return (
    <Box sx={{ width: "100%", height: 10, display: "flex", borderRadius: 5, overflow: "hidden", bgcolor: "#eeeeee" }}>
      <Tooltip title={`Correct: ${Math.round(correctWidth)}%`}>
        <Box sx={{ width: `${correctWidth}%`, bgcolor: "#512384", height: "100%" }} />
      </Tooltip>
      <Tooltip title={`Wrong: ${Math.round(wrongWidth)}%`}>
        <Box sx={{ width: `${wrongWidth}%`, bgcolor: "#eb3c96", height: "100%" }} />
      </Tooltip>
    </Box>
  );
};

export default function QuizAnalysis({ quizId }: { quizId: number | string | undefined }) {

  const numericId = typeof quizId === 'string' ? parseInt(quizId, 10) : quizId;



const { data: analytics, isFetching: loadingAnalytics } = useGetQuizAnalyticsQuery(
    numericId as number,
    { skip: !numericId }
  );




  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
      <CardHeader
        title={
          <Typography variant="h6" sx={{ color: "#eb3c96", fontWeight: "bold", m: 0 }}>
            Question Difficulty Analysis
          </Typography>
        }
        sx={{ bgcolor: "#f8f8f8" }}

      />
      <CardContent>
        {loadingAnalytics ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper} elevation={0} >
            <Table size="small"  stickyHeader aria-label="quiz analysis table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", width: "10%" }}>Index</TableCell>
                  <TableCell sx={{ fontWeight: "bold", width: "35%" }}>Question</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>Correct</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>False</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>Total</TableCell>
                  <TableCell sx={{ fontWeight: "bold", width: "20%" }}>Success Rate</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {analytics && analytics.length > 0 ? (
                  analytics.map((q: any, index: number) => {
                    const total = q.totalResponses || (q.correctAnswers + q.wrongAnswers) || 0;
                    return (
                      <TableRow key={index} hover>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell sx={{ maxWidth: 300, whiteSpace: "normal", wordWrap: "break-word" }}>
                          {q.questionText}
                        </TableCell>
                        <TableCell align="center" sx={{ color: "#512384", fontWeight: "bold" }}>
                          {q.correctAnswers}
                        </TableCell>
                        <TableCell align="center" sx={{ color: "#eb3c96", fontWeight: "bold" }}>
                          {q.wrongAnswers}
                        </TableCell>
                        <TableCell align="center">{total}</TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                            <MultiColorBar correct={q.correctAnswers} wrong={q.wrongAnswers} />
                            <Typography variant="caption" color="text.secondary">
                              {total > 0 ? `${Math.round((q.correctAnswers / total) * 100)}% Correct` : "No data"}
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
                      
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
}